import { Button } from "@/components/ui/button";
import { Phone, Mail, MessageCircle, Calendar } from "lucide-react";
import QuickContactForm from "./QuickContactForm";

interface ContactCTASectionProps {
  onBookingClick: () => void;
}

const ContactCTASection = ({ onBookingClick }: ContactCTASectionProps) => {
  return (
    <section id="contact" className="py-20 bg-gradient-to-br from-primary/5 via-background to-accent/5">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-serif font-light mb-6">
            Ready to Transform Your Space?
          </h2>
          <p className="text-xl text-muted-foreground mb-8">
            Choose the option that works best for you. We're here to help every step of the way.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start max-w-6xl mx-auto">
          {/* Quick Contact Options */}
          <div className="space-y-8">
            <div className="text-center lg:text-left">
              <h3 className="text-2xl font-serif font-medium mb-6">Get Started Instantly</h3>
              <div className="grid sm:grid-cols-2 gap-4">
                <Button 
                  size="lg"
                  className="luxury-gradient text-white h-16 text-base group"
                  onClick={() => window.open('tel:+16167270343')}
                >
                  <Phone className="w-5 h-5 mr-3 group-hover:scale-110 transition-transform" />
                  <div className="text-left">
                    <div className="font-semibold">Call Now</div>
                    <div className="text-sm opacity-90">616 727-0343</div>
                  </div>
                </Button>

                <Button 
                  size="lg"
                  variant="outline"
                  className="h-16 text-base border-primary text-primary hover:bg-primary hover:text-white group"
                  onClick={() => window.open('mailto:hello@organizebydesignmichigan.com')}
                >
                  <Mail className="w-5 h-5 mr-3 group-hover:scale-110 transition-transform" />
                  <div className="text-left">
                    <div className="font-semibold">Email Us</div>
                    <div className="text-sm opacity-70">Quick response</div>
                  </div>
                </Button>

                <Button 
                  size="lg"
                  variant="outline"
                  className="h-16 text-base border-accent text-accent hover:bg-accent hover:text-white group"
                  onClick={() => window.open('sms:+16167270343')}
                >
                  <MessageCircle className="w-5 h-5 mr-3 group-hover:scale-110 transition-transform" />
                  <div className="text-left">
                    <div className="font-semibold">Text Us</div>
                    <div className="text-sm opacity-70">Fastest reply</div>
                  </div>
                </Button>

                <Button 
                  size="lg"
                  variant="secondary"
                  className="h-16 text-base group"
                  onClick={onBookingClick}
                >
                  <Calendar className="w-5 h-5 mr-3 group-hover:scale-110 transition-transform" />
                  <div className="text-left">
                    <div className="font-semibold">Full Booking</div>
                    <div className="text-sm opacity-70">Complete details</div>
                  </div>
                </Button>
              </div>
            </div>

            {/* Trust Indicators */}
            <div className="bg-white/80 backdrop-blur rounded-lg p-6 border border-primary/10">
              <h4 className="font-semibold mb-4 text-center lg:text-left">Why Choose Us?</h4>
              <div className="grid sm:grid-cols-2 gap-4 text-sm">
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-primary rounded-full"></div>
                  <span>Free consultations</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-primary rounded-full"></div>
                  <span>Licensed & insured</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-primary rounded-full"></div>
                  <span>10+ years experience</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-primary rounded-full"></div>
                  <span>BBB accredited</span>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div>
            <QuickContactForm />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactCTASection;